import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { PagedResponse, SystemParameter, SystemParameterUpdate } from '../types'

const BASE = '/management/system-parameters'

/** Sistem parametreleri (opsiyonel arama q; size=200). */
export async function getSystemParameters(q?: string): Promise<PagedResponse<SystemParameter>> {
  const { data } = await apiClient.get<PagedResponse<SystemParameter>>(BASE, {
    params: { page: 0, size: 200, q: q && q.trim() ? q.trim() : undefined },
  })
  return data
}

/** Yalnız değer güncelle (optimistic lock modDate). */
export async function updateSystemParameter(
  id: number,
  body: SystemParameterUpdate,
): Promise<SystemParameter> {
  const { data } = await apiClient.put<SystemParameter>(`${BASE}/${id}`, body)
  return data
}

/**
 * Sistem parametrelerini Excel (.xlsx) olarak indirir.
 *
 * Liste ucuyla aynı filtreler; sunucu **tüm** filtreli kayıtları döndürür (sayfalama yok). İndirme
 * mekaniği ve dosya adı ortak {@link downloadXlsx} yardımcısındadır (boş filtreler gönderilmez; ad
 * sunucunun Content-Disposition'ından okunur).
 */
export async function exportSystemParameters(q?: string): Promise<void> {
  await downloadXlsx(`${BASE}/export`, { q }, 'sistem-parametreleri.xlsx')
}
